import * as tslib_1 from "tslib";
export function normalizeFeatures(features) {
  var availableFeatures = {};
  features.forEach(function (feature) {
    var enabled = feature.enabled,
        otherFeatureOptions = tslib_1.__rest(feature, ["enabled"]);

    availableFeatures[feature.type] = tslib_1.__assign({}, otherFeatureOptions, {
      isEnabled: enabled
    });
  });
  return availableFeatures;
}